const map: { [key: string]: string } = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;",
  "`": "&#x60;",
  "=": "&#x3D;"
};

const reverse: { [key: string]: string } = {};

Object.keys(map).forEach(key => {
  reverse[map[key]] = key;
});

export const escapes = (s: string): string => s.replace(/[&<>"'`=/]/g, a => map[a]);

export const unescapes = (s: string): string => {
  let back = s;

  Object.keys(reverse).forEach(key => {
    const regex = new RegExp(key, "g");
    back = back.replace(regex, reverse[key]);
  });

  return back;
};
